import CostCreate from '_modules/cost/views/CostCreate.vue';
import CostEdit from '_modules/cost/views/CostEdit.vue';
import CostList from '_modules/cost/views/CostList.vue';
import Cost from './Root.vue';

export default {
  path: 'custos/',
  component: Cost,
  name: 'admin-service',
  redirect: '/custos/lista/1',
  children: [
    {
      path: 'lista/:page',
      name: 'admin-cost-list',
      component: CostList,
    },
    {
      path: 'novo/',
      name: 'admin-cost-new',
      component: CostCreate,
    },
    {
      path: ':costId',
      name: 'admin-cost-edit',
      component: CostEdit,
    },
  ],
};
